import { memo } from 'react';

import { convertDateString } from 'src/utils/dateFormat';

const SentAtRendererComponent = ({ data }) => convertDateString(data.createdAt, 'MM/DD/YYYY hh:mm A');

export const SentAtRenderer = memo(SentAtRendererComponent);
